/**
 * @description Сохранить фильтры CRM.
 * @type {string}
 */
export const STORE_CRM_FILTERS = 'STORE_CRM_FILTERS';

/**
 * @description Очистить фильтры CRM.
 * @type {string}
 */
export const CLEAR_CRM_FILTERS = 'CLEAR_CRM_FILTERS';
